import { createContext, useContext } from "react";

import type { Label } from "~/providers/label-provider";

interface LabelContext {
  labels: Label[];
}

export const LabelContext = createContext<LabelContext | undefined>(undefined);

export const useLabel = () => {
  const context = useContext(LabelContext);

  if (context === undefined) {
    throw new Error(
      "useLabel must be used within a LabelProvider, but no provider was found",
    );
  }

  return context;
};
